module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-6.53184ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-6.png
// module id = Vr/N
// module chunks = 34